module.exports = __webpack_public_path__ + "img/badge_booking.83e4f2ce.png";